import { Drawer } from '@/new/components/drawers/drawer';
import { DocumentDrawerContent } from '@/new/components/reference-content/document-drawer-content';

interface DocumentDrawerProps {
  docId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function DocumentDrawer({ docId, isOpen, onClose }: DocumentDrawerProps) {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      {docId && <DocumentDrawerContent docId={docId} onClose={onClose} />}
    </Drawer>
  );
}
